export const ACTIVITY_TABLE_HEADINGS = ["Action", "User", "Detail", "Date"];

/**
 * Object types in the audit system
 * @enum {string}
 */
export const OBJECT_TYPES = {
  SCHEDULE: "schedule",
  OBLIGATION_ASSOCIATION: "obligation_association",
  PAYMENT_INSTRUMENT: "payment_instrument",
  PROFILE: "profile",
  SESSION: "session"
};

/**
 * Object subtypes in the audit system
 * @enum {string}
 */
export const OBJECT_SUBTYPES = {
  BANK_ACCOUNT_CHECKING: "bank_account/checking",
  BANK_ACCOUNT_SAVINGS: "bank_account/savings",
  CREDIT_CARD: "credit_card"
};

/**
 * Field names that can be changed in audit entries
 * @enum {string}
 */
export const CHANGE_FIELDS = {
  STATUS: "status",
  ACCOUNT_ID: "account_id",
  OBLIGATION_ASSOCIATION_ID: "obligation_association_id"
};

/**
 * Available actions in the audit system
 * @enum {string}
 */
export const ACTIONS = {
  CREATE: "create",
  DELETE: "delete",
  UPDATE: "update"
};

/**
 * Status values for audit entries
 * @enum {string}
 */
export const STATUSES = {
  PENDING: "pending",
  ACTIVE: "active"
};

export const ACTIVITY_ACTION_LABELS = new Map([
  ["schedule.create", "Autopay activated"],
  ["schedule.delete", "Autopay deactivated"],
  ["obligation_association.create", "Account added to wallet"],
  ["obligation_association.delete", "Account removed from wallet"],
  ["payment_instrument.create", "Payment method added"],
  ["payment_instrument.delete", "Payment method removed"],
  ["profile.create", "Wallet registration email sent"],
  ["profile.create_active", "Wallet created"],
  ["profile.update", "Wallet updated"],
  ["profile.delete", "Wallet deleted"],
  ["session.create", "Wallet login"]
]);

export const DATE_FORMAT = "MM/DD/YYYY - hh:mm:ss A";

// Blank cell intentionally rendered when audit entry does not need additional data coming from the display cache
export const NOT_AVAILABLE = "";

/**
 * Object types that have display cache details for UI display
 * @enum {Array<string>}
 */
export const DISPLAY_CACHE_OBJECT_TYPES = [
  OBJECT_TYPES.SCHEDULE,
  OBJECT_TYPES.OBLIGATION_ASSOCIATION,
  OBJECT_TYPES.PAYMENT_INSTRUMENT
];
